import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useSearch } from "../context/SearchContext";
import Gallery from "../components/Gallery";

function matchQuery(filename, query) {
  if (!query.trim()) return true;
  const terms = query.toLowerCase().split(/\s+/).filter(Boolean);
  return terms.every((t) => filename.toLowerCase().includes(t));
}

export default function VersionPage() {
  const { versionId } = useParams(); // e.g. v1, v2, vforeign, visps, unknown
  const [allImages, setAllImages] = useState([]);
  const { query } = useSearch();

  useEffect(() => {
    fetch("/images/index.json")
      .then((res) => res.json())
      .then((data) => setAllImages(data));
  }, []);

  // ✅ Scroll to top when query changes
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [query]);

  let versionFilter;
  if (versionId === "unknown") {
    versionFilter = "Unknown";
  } else if (versionId === "vforeign") {
    versionFilter = "vforeign";
  } else if (versionId === "visps") {
    versionFilter = "visps";
  } else {
    versionFilter = `Version ${versionId}.x`;
  }

  let filtered;
  if (query.trim()) {
    filtered = allImages.filter((img) => matchQuery(img.filename, query));
  } else {
    filtered = allImages.filter((img) => img.version === versionFilter);
  }

  // ✅ Custom titles
  let pageTitle;
  if (query.trim()) {
    pageTitle = `Global search for “${query.trim()}”`;
  } else if (versionId === "unknown") {
    pageTitle = "Unknown Version Disks";
  } else if (versionId === "vforeign") {
    pageTitle = (
      <div style={{ textAlign: "center" }}>
        Foreign
        <br />
        <span style={{ fontSize: "0.85em", color: "#888" }}>
          (Under Construction)
        </span>
      </div>
    );
  } else if (versionId === "visps") {
    pageTitle = (
      <div style={{ textAlign: "center" }}>
        Other ISPs
        <br />
        <span style={{ fontSize: "0.85em", color: "#888" }}>
          (Coming Soon!)
        </span>
      </div>
    );
  } else {
    pageTitle = `Version ${versionId}.x Disks`;
  }

  return (
    <>
      <h2 style={{ textAlign: "center", marginTop: "1rem" }}>{pageTitle}</h2>
      {filtered.length > 0 ? (
        <Gallery images={filtered} />
      ) : (
        <p style={{ textAlign: "center", marginTop: "2rem" }}>
          No {query.trim() ? "search results" : "images"} found.
        </p>
      )}
    </>
  );
}
